import type { AdminLabDirectoryResponse } from "../../services/labService";
import type { LabType } from "../../types/lab";

interface AdminLabFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedStatus: "all" | AdminLabDirectoryResponse["filter_options"]["certification_statuses"][number]["value"];
  onStatusChange: (
    value: "all" | AdminLabDirectoryResponse["filter_options"]["certification_statuses"][number]["value"],
  ) => void;
  selectedLabType: LabType | null;
  onLabTypeChange: (value: LabType | null) => void;
  showTypeFilters: boolean;
  availableLabTypes: AdminLabDirectoryResponse["filter_options"]["lab_types"];
  statusOptions: AdminLabDirectoryResponse["filter_options"]["certification_statuses"];
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

export const AdminLabFilters = ({
  searchTerm,
  onSearchChange,
  selectedStatus,
  onStatusChange,
  selectedLabType,
  onLabTypeChange,
  showTypeFilters,
  availableLabTypes,
  statusOptions,
  hasActiveFilters,
  onClearFilters,
}: AdminLabFiltersProps) => {
  return (
    <div className="card border-2 border-solid border-[#eaddc9] bg-[#fefcf3] shadow-sm">
      <div className="card-body gap-4">
        <div className="grid gap-4 lg:grid-cols-[minmax(0,1.6fr)_minmax(220px,0.7fr)_auto] lg:items-start">
          <label className="form-control w-full">
            <span className="label-text mb-2 text-sm font-medium">Search</span>
            <input
              type="text"
              value={searchTerm}
              onChange={(event) => onSearchChange(event.target.value)}
              className="input input-bordered w-full"
              placeholder="Search labs by name or champion..."
            />
          </label>

          <label className="form-control w-full">
            <span className="label-text mb-2 text-sm font-medium">Certification status</span>
            <select
              value={selectedStatus}
              onChange={(event) =>
                onStatusChange(
                  event.target.value as
                    | "all"
                    | AdminLabDirectoryResponse["filter_options"]["certification_statuses"][number]["value"],
                )
              }
              className="select select-bordered w-full"
            >
              <option value="all">All</option>
              {statusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>

          {hasActiveFilters ? (
            <div className="flex items-end">
              <button type="button" className="btn btn-ghost btn-sm" onClick={onClearFilters}>
                Clear filters
              </button>
            </div>
          ) : (
            <div />
          )}
        </div>

        {showTypeFilters && (
          <div className="space-y-2">
            <p className="text-sm font-medium">Lab type</p>
            <div className="flex flex-wrap gap-2">
              {availableLabTypes.map((option) => {
                const isActive = selectedLabType === option.value;
                return (
                  <button
                    key={option.value}
                    type="button"
                    className={`btn btn-sm ${isActive ? "btn-primary" : "btn-outline"}`}
                    onClick={() => onLabTypeChange(isActive ? null : option.value)}
                  >
                    {option.label}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};